/**
 * Pomodoro count limits.
 *
 * Must match maxPomodoroCount in:
 * - apps/consumer/processors/actions/update-task/processor.go
 * - apps/consumer/processors/actions/create-task/processor.go
 */
export const MAX_POMODORO_COUNT = 200;
